import React from "react";
import styled from "styled-components";

const LoaderStyled = styled.div`
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    top: 0;
    background: #ffffff78;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
`;

const Loader = ({show}: any) => {
    return !show ? null :
        <LoaderStyled>
        {/*<img alt='loader' src='/images/Dual_Ring-1s-200px-blue.svg'/>*/}
            <div className="loader">
                <div className="outer"></div>
                <div className="middle"></div>
                <div className="inner"></div>
            </div>
    </LoaderStyled>;
};

export default Loader;
